const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'login',
    path: `${prefix}/cms/login`,
    method: 'post',
    params: {
      username: '',
      password: '',
      validateCode: '',
      sign: 'cms'
    },
    desc: '登录'
  },
  {
    name: 'logout',
    path: `${prefix}/cms/logout`,
    method: 'get',
    params: {},
    desc: '退出登录'
  },
  {
    name: 'resigterCode',
    path: `${prefix}/message/regist/code`,
    method: 'get',
    params: {
      email: '',
      from: 'register'
    },
    desc: '注册验证码'
  },
  {
    name: 'register',
    path: `${prefix}/cms/register`,
    method: 'post',
    params: {
      username: '',
      email: '',
      password: '',
      verifyCode: '',
      inviteCode: ''
    },
    desc: '注册'
  },
  {
    name: 'getUserEmail',
    path: `${prefix}/cms/getUserEmail`,
    method: 'get',
    params: {
      consumerName: ''
    },
    desc: '获取用户邮箱'
  },
  {
    name: 'getUserEmail-manage',
    path: `${prefix}/pms/getUserEmail`,
    method: 'get',
    params: {
      consumerName: ''
    },
    desc: '获取用户邮箱-后管账号'
  },
  {
    name: 'forgetCode',
    path: `${prefix}/message/forget/code`,
    method: 'get',
    params: {
      consumerName: ''
    },
    desc: '获取忘记密码验证码'
  },
  {
    name: 'forgetCode-manage',
    path: `${prefix}/message/pms/forget/code`,
    method: 'get',
    params: {
      consumerName: ''
    },
    desc: '获取忘记密码验证码-后管账号'
  },
  {
    name: 'resetValidate',
    path: `${prefix}/cms/reset/validate`,
    method: 'post',
    params: {
      loginName: '',
      verifyCode: ''
    },
    desc: '忘记密码验证码校验'
  },
  {
    name: 'resetValidate-manage',
    path: `${prefix}/pms/reset/validate`,
    method: 'post',
    params: {
      loginName: '',
      verifyCode: ''
    },
    desc: '忘记密码验证码校验-后管账号'
  },
  {
    
    name: 'resetPassword',
    path: `${prefix}/cms/reset/password`,
    method: 'post',
    params: {
      loginName: '',
      verifyCode: '',
      password: ''
    },
    desc: '忘记密码'
  },
  {
    
    name: 'resetPassword-manage',
    path: `${prefix}/pms/reset/password`,
    method: 'post',
    params: {
      loginName: '',
      verifyCode: '',
      password: ''
    },
    desc: '忘记密码-后管账号'
  }
]
